import { Redirect, Route } from 'react-router-dom';
import React from 'react';
import * as ROUTES from '../../constants/routes';
import UserManager from '../../UserManager';

const PrivateRoute = ({ children, ...rest }) => {
  const isAuth = UserManager.getInstance().isAuthenticated();

  return (
    <Route
      {...rest}
      render={() => (isAuth ? (
        children
      ) : (
        <Redirect
          to={{
            pathname: ROUTES.SIGN_IN,
          }}
        />
      ))}
    />
  );
};

export default PrivateRoute;
